module.exports = __webpack_public_path__ + "static/img/visit.4f64dd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/visit.png
// module id = s7gn
// module chunks = 1